import {Button} from '@mantine/core';
import React from 'react';
import {EdgeLabelRenderer, EdgeProps} from 'reactflow';

import {EdgesContext} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/EdgesContext';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {
  FLOWCHART_ICON_BUTTON_PROPS,
  useFlowchartIconButtonStyles,
} from 'ui-library/reactflow/buttons/flowchartButtonStyles';
import {getEdgeMidpointLabelCoords} from 'ui-library/reactflow/edges/ElkSplineEdgeRenderer';

export default function RemoveEdgeLabel(props: EdgeProps): JSX.Element {
  const {classes} = useFlowchartIconButtonStyles();
  const {onEdgeRemove} = EdgesContext.useContext();
  const {labelX, labelY} = getEdgeMidpointLabelCoords(props);

  return (
    <EdgeLabelRenderer>
      <div
        style={{
          position: 'absolute',
          transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
          pointerEvents: 'all',
        }}
        className="nopan"
      >
        <Button.Group>
          <Button
            {...FLOWCHART_ICON_BUTTON_PROPS}
            onClick={() => {
              onEdgeRemove(props.id);
            }}
            classNames={{root: classes.root}}
            aria-label="Remove edge"
          >
            <BenchlingIcon icon="trash-can" />
          </Button>
        </Button.Group>
      </div>
    </EdgeLabelRenderer>
  );
}
